import { render } from "./EmbedBot.vue?vue&type=template&id=50e62d1c"
const script = {}

import "./EmbedBot.vue?vue&type=style&index=0&id=50e62d1c&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__